module.exports = __webpack_public_path__ + "static/android-location-permission-new-d485e2e477eed0d118cd88694026448a.png";